export class StepperMessages {
  public choice = 'stepper.choice';
  public generate = 'stepper.generate';
  public nextStep = 'stepper.next_step';
  public prerequisite = 'stepper.prerequisite';
  public previousStep = 'stepper.previous_step';
  public validateStepperProcess = 'stepper.validation_step';
  public result = 'stepper.result';
  public upload = 'stepper.upload';

  constructor() {
  }
}
